import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError.ts';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import { preloadOptions } from '../Options/preloadOptions.ts';

import { getRecentQueryOptions } from './recentQueryHelpers.ts';
import { HomeRecentUserPreferencesQuery } from './HomeRecentQueries.graphql.ts';

export const preloadRecent = ({
	cloudId,
	isLoggedIn,
	isWhiteboardViewedEnabled,
	isWhiteboardUpdatedEnabled,
}: {
	cloudId: string;
	isLoggedIn: boolean;
	isWhiteboardViewedEnabled?: boolean;
	isWhiteboardUpdatedEnabled?: boolean;
}) => {
	return waitForAllReturnWhenError([
		query<unknown, {}>(
			/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
			getRecentQueryOptions({
				pill: 'all',
				cloudId,
				endCursor: '',
				isWhiteboardViewedEnabled,
				isWhiteboardUpdatedEnabled,
			}),
		),
		preloadOptions({ isLoggedIn }),
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		...(isLoggedIn ? [query({ query: HomeRecentUserPreferencesQuery })] : []),
	]);
};
